import useAxios from 'axios-hooks';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../routes/RouterPaths';
import { Button } from '../../styled/buttons/Button';
import { MainCardContainer } from '../../styled/containers/MainCardContainer';
import { H2 } from '../../styled/miscellaneous/hx';
import { Table, Th, Tr } from '../../styled/table/table';
import { ApiKey, IApiKey } from '../../types/axios/apiKeys';
import { AUTH_ERROR, isAxiosError } from '../../utils/axiosUtils';
import CentredLoader from '../miscellaneous/CenteredLoader';
import ErrorBox from '../miscellaneous/ErrorBox';
import { useAuth } from '../../hooks/useAuth';
import KeyRow from './KeyRow';

const ApiKeys: FC = () => {
  const [postError, setPostError] = useState(false);
  const navigate = useNavigate();
  const { token } = useAuth();
  const [{ data, loading, error }, fKeys] = useAxios<ApiKey[]>({
    url: '/apiKey/getAll',
    method: 'GET',
    headers: { authorization: token },
  });

  useEffect(() => {
    if (error && isAxiosError(error, AUTH_ERROR)) {
      navigate(RouterPaths.LOG_OUT);
    }
  }, [error, navigate]);

  const [, createKey] = useAxios<boolean>(
    {
      url: '/apiKey/add',
      method: 'POST',
      headers: { authorization: token },
    },
    { manual: true },
  );

  const fetchKeys = async () => {
    await fKeys();
  };

  const onAddNew = async () => {
    setPostError(false);
    try {
      await createKey({
        data: { exchangeName: '', key: '', secret: '', userId: '' } as IApiKey,
      });
      await fetchKeys();
    } catch (error) {
      if (isAxiosError(error, AUTH_ERROR)) {
        navigate(RouterPaths.LOG_OUT);
      } else {
        setPostError(true);
      }
    }
  };

  return (
    <MainCardContainer>
      <div>
        <H2>Api Keys</H2>
        {loading || !data ? (
          <CentredLoader />
        ) : error ? (
          <ErrorBox />
        ) : (
          <>
            <Table>
              <tbody>
                <Tr>
                  <Th>Exchange name</Th>
                  <Th>Key</Th>
                  <Th>Secret</Th>
                  <Th>User Id</Th>
                  <Th colSpan={2}>Actions</Th>
                </Tr>
                {data.map(key => (
                  <KeyRow
                    key={key.id}
                    keyData={key}
                    setPostError={setPostError}
                    fetchKeys={fetchKeys}
                  />
                ))}
              </tbody>
            </Table>
            <div style={{ display: 'flex' }}>
              {postError && <ErrorBox />}
              <Button
                blue
                style={{
                  marginTop: 15,
                  width: 150,
                  padding: 10,
                  marginLeft: 'auto',
                  display: 'inline-flex',
                }}
                onClick={onAddNew}
              >
                Add New
              </Button>
            </div>
          </>
        )}
      </div>
    </MainCardContainer>
  );
};

export default ApiKeys;
